// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SkillsList_wrapper__1CXVK","list":"SkillsList_list__1SJA8","listItem":"SkillsList_listItem__2C0tp","mobileHidden":"SkillsList_mobileHidden__1R-an"};